import React, { useEffect, useState } from 'react';
import Header from '../../../Components/Header';
import AccountSidebar from '../AccountSidebar';
import { BrowserView, MobileView } from 'react-device-detect';
import { ApiService } from '../../../Components/Services/apiServices';

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [user, setUser] = useState(null);


    useEffect(() => {
        const userData = localStorage.getItem("USER_DATA");
        if (userData) {
            const parsedUser = JSON.parse(userData);
            setUser(parsedUser);
        }
    }, []);

    const handlePasswordChange = async () => {
        if (!newPassword || !confirmPassword) {
            setError("Both fields are required.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            const response = await ApiService.Commanpostrequest("update-password", {
                user_id: user.id,
                new_password: newPassword,
                new_password_confirmation: confirmPassword
            });

            if (response?.data?.success) {
                setSuccessMessage("Password updated successfully!");
                setNewPassword('');
                setConfirmPassword('');
            } else {
                setSuccessMessage("Password updated successfully!");
                setNewPassword('');
                setConfirmPassword('');
            }
        } catch (error) {
            console.error("Error updating password:", error);
            setError("An error occurred. Please try again.");
        }
    };

    return (
        <>
            <Header />
            <BrowserView>
                <div className="account-container">
                    <AccountSidebar />
                    <div className="account-content container py-5">
                        <div className="col-lg-9 col-md-8">
                            <div className="card shadow-sm border-0 p-4">
                                <h3 className="mb-4 text-center text-md-start">Change Password</h3>

                                {/* Display error or success messages */}
                                {error && <div className="alert alert-danger">{error}</div>}
                                {successMessage && <div className="alert alert-success">{successMessage}</div>}

                                <div className="profile-details">
                                    <div className="mt-4">
                                        <ul className="list-group">
                                            <li className="list-group-item">
                                                <strong>New Password:</strong>
                                                <input
                                                    type="password"
                                                    className="form-control mt-2"
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                />
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Confirm New Password:</strong>
                                                <input
                                                    type="password"
                                                    className="form-control mt-2"
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                            </li>
                                        </ul>
                                        <button className='btn btn-primary w-50 mt-4' onClick={handlePasswordChange}>Update Password</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div className="col-lg-9 col-md-8">
                    <div className="card shadow-sm border-0 p-4">
                        <h3 className="mb-4 text-center text-md-start mt-5">Change Password</h3>

                        {/* Display error or success messages */}
                        {error && <div className="alert alert-danger">{error}</div>}
                        {successMessage && <div className="alert alert-success">{successMessage}</div>}

                        <div className="profile-details">
                            <div className="mt-4">
                                <ul className="list-group">
                                    <li className="list-group-item">
                                        <strong>New Password:</strong>
                                        <input
                                            type="password"
                                            className="form-control mt-2"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                    </li>
                                    <li className="list-group-item">
                                        <strong>Confirm New Password:</strong>
                                        <input
                                            type="password"
                                            className="form-control mt-2"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                    </li>
                                </ul>
                                <div className='text-center'>
                                <button className='btn btn-primary w-50 mt-4' onClick={handlePasswordChange}>Update Password</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MobileView>
        </>
    );
};

export default ChangePassword;
